import ArrowRight from '@/assets/svg/icons/arrow-right.svg?inline'
import EmailIcon from '@/assets/svg/icons/envelope.svg?inline'
import LoginButtons from '@/components/Account/LoginButtons'
import LoginButton from '@/components/Account/LoginButton'
import TextInput from '@/components/form/TextInput'
import { fields } from '@/mixins/content'
import { mapState, mapGetters } from 'vuex'

export default {
  props: {
    showContinueButton: { type: Boolean, default: true },
    showSocialButtons: { type: Boolean, default: true },
    handleByParent: { type: Boolean, default: false },
    promptAlign: { type: String, default: 'center' },
    oauthParams: { type: Object, default: () => ({}) },
  },

  mixins: [fields],

  components: { EmailIcon, LoginButtons, LoginButton, ArrowRight, TextInput },

  computed: {
    ...mapState(['flags']),

    enableSocialButtons() {
      return this.showSocialButtons && this.isUs
    },

    enableContinueButton() {
      return (
        this.showContinueButton ||
        (this.showContinueButton && this.remainingLoginAttempts)
      )
    },

    ...mapGetters(['isUs']),
  },
}
